import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

import '../App.css';

function Home () {
    
    return (

    <section id="home" className="block about-block">    
        <Container fluid>
            <Row>
                <Col xs={6}>
                    <Container id="namebox">
                        <Stack gap={2}>
                            <div className="p-1"><h1 id="name">John Rey Tolosa</h1></div>
                            <div className="p-1">
                                <p className="subtitle">A</p>
                                <p className="subtitle" id="green-subtitle">Computer Science</p>
                                <p className="subtitle">Student from Naga College Foundation</p>
                            </div>
                            <Stack direction="horizontal" gap={3}>
                            <ButtonToolbar aria-label="Toolbar with button groups">
                                <ButtonGroup className="me-2" aria-label="First group">
                                    <Button  id='buttongroup'>Home</Button> 
                                    <Button  id='buttongroup' href="#about">About</Button> 
                                    <Button id='buttongroup' href="#education">Education</Button>
                                    <Button id='buttongroup' href="#skills">Skills</Button>
                                    <Button id='buttongroup' href="#contacts">Contacts </Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                            </Stack>
                        </Stack>
                    </Container>
                </Col>
                <Col xs={6}>
                    <Image id="myImage" src={require("../assets/images/JohnRey.png")} />
                </Col>
            </Row>
        </Container>

    </section>
    )
}

export default Home;
